import commons from './commons';

let querySelectionPrefix = [
    {
        id: 'documentId',
        displayName: "ID",
        system: true,
        fieldName: "documentId",
        type: 0
    },
    {
        id: 'state',
        displayName: "State",
        system: true,
        fieldName: "state",
        type: "state"
    },
    {
        id: 'collaboration',
        displayName: "Collaboration",
        system: true,
        fieldName: "collaboration",
        type: "collaboration"
    },
    {
        id: 'date',
        displayName: "Date",
        system: true,
        fieldName: "date",
        type: 5
    },
    {
        id: 'assignTo',
        displayName: "Assign To",
        system: true,
        fieldName: "assignTo",
        type: 20
    },
    {
        id: 'due',
        displayName: "Due",
        system: true,
        fieldName: "due",
        type: 5
    },
    {
        id: 'createdBy',
        displayName: 'Created By',
        system: true,
        fieldName: "createdBy",
        type: 20
    },
    {
        id: 'createdDate',
        displayName: "Created Date",
        system: true,
        fieldName: "createdDate",
        type: 5
    },
    {
        id: 'lastChangeBy',
        displayName: "Last Change By",
        system: true,
        fieldName: "lastChangeBy",
        type: 20
    },
    {
        id: 'lastChangeDate',
        displayName: "Last Change Date",
        system: true,
        fieldName: "lastChangeDate",
        type: 5
    },
    {
        id: "username",
        displayName: "Username",
        system: true,
        fieldName: "username",
        type: 19,
    }
];

let querySelectionSuffix = [
    {
        displayName: "OR",
        fieldName: "or",
        type: "condition"
    },
    {
        displayName: "AND",
        fieldName: "and",
        type: "condition"
    },
    {
        displayName: "NOT",
        fieldName: "not",
        type: "condition"
    },
    {
        displayName: "Formula",
        fieldName: "formula",
        type: "formula"
    },
    {
        displayName: "Script",
        fieldName: "script",
        type: "custom"
    }
];

let querySelectionSpecial = [
    {
        displayName: "OR",
        fieldName: "or",
        type: "condition"
    },
    {
        displayName: "AND",
        fieldName: "and",
        type: "condition"
    },
    {
        displayName: "NOT",
        fieldName: "not",
        type: "condition"
    },
    {
        displayName: "Script",
        fieldName: "script",
        type: "custom"
    }
];

let getInformationType = function (informationSource, fieldName) {
    var filterType = null;
    if (informationSource.some(x => x.fieldName === fieldName)) {
        filterType = informationSource.find(x => x.fieldName === fieldName).type;
    }

    if (Number.isInteger(filterType)) {
        return commons.informationTypes.find(x => x.id == filterType).type;
    }

    return filterType;
}

let getInformation = function (informationSource, fieldName) {
    if (informationSource.some(x => x.fieldName === fieldName)) {
        return informationSource.find(x => x.fieldName === fieldName);
    }

    return null;
}

let getSearchTypes = function (filterType) {
    switch (filterType) {
        case "Text":
        case "Multiline Text":
        case "Select":
        case "Locus":
        case "Module":
        case "Email":
        case "Phone Number":
        case "Link":
            return [
                { displayName: "contains", fieldName: "contains" },
                { displayName: "is", fieldName: "is" },
                { displayName: "starts with", fieldName: "startsWith" },
                { displayName: "ends with", fieldName: "endsWith" },
                { displayName: "blank", fieldName: "isNone" }
            ];

        case "Integer":
        case "Number":
        case "Money":
            return [
                { displayName: "between", fieldName: "between" },
                { displayName: "greater than or equal", fieldName: "gte" },
                { displayName: "less than or equal", fieldName: "lte" },
                { displayName: "equal", fieldName: "eq" },
                { displayName: "blank", fieldName: "isNone" }
            ];

        case "YesNo":
            return [
                { displayName: "yes", fieldName: "yes" },
                { displayName: "no", fieldName: "no" },
                { displayName: "blank", fieldName: "none" }
            ];

        case "Date":
        case "Date Time":
            return [
                { displayName: "between", fieldName: "between" },
                { displayName: "within", fieldName: "within" },
                { displayName: "after", fieldName: "gte" },
                { displayName: "before", fieldName: "lte" },
                { displayName: "in", fieldName: "in" },
                { displayName: "past", fieldName: "past" }
            ];

        case "User":
        case "Profile (Module)":
        case "Username":
            return [
                { displayName: "is me", fieldName: "me" },
                { displayName: "is", fieldName: "is" },
                { displayName: "contains", fieldName: "contains" },
                { displayName: "blank", fieldName: "none" }
            ];

        case "collaboration":
            return [
                {
                    displayName: "intentation and comment last",
                    fieldName: "lastIntentionComment"
                },
                { displayName: "intentation last", fieldName: "lastIntention" },
                { displayName: "comment last", fieldName: "lastComment" },
                { displayName: "intention", fieldName: "intention" },
                { displayName: "comment", fieldName: "comment" },
                { displayName: "blank", fieldName: "none" }
            ];

        case "state":
            return [
                { displayName: "is", fieldName: "is" },
                { displayName: "not", fieldName: "isNot" }
            ];

        case "formula":
            return [
                { displayName: "is", fieldName: "is" },
                { displayName: "not", fieldName: "isNot" },
                { displayName: "greater than", fieldName: "gt" },
                { displayName: "less than", fieldName: "lt" },
                { displayName: "greater than or equal", fieldName: "gte" },
                { displayName: "less than or equal", fieldName: "lte" },
                { displayName: "equal", fieldName: "eq" },
            ];
    }
};

let getDatePredefinedselection = function (durationType) {
    switch (durationType) {
        case 'day':
            return [
                { displayName: "today (" + moment().format("dddd") + ")", offset: 0 },
                {
                    displayName:
                        "yesterday (" +
                        moment()
                            .subtract(1, "days")
                            .format("dddd") +
                        ")",
                    offset: -1
                },
                {
                    displayName:
                        "previous day (" +
                        moment()
                            .subtract(2, "days")
                            .format("dddd") +
                        ")",
                    offset: -2
                },
                {
                    displayName:
                        "tomorrow (" +
                        moment()
                            .add(1, "days")
                            .format("dddd") +
                        ")",
                    offset: 1
                },
                {
                    displayName:
                        "next day (" +
                        moment()
                            .add(2, "days")
                            .format("dddd") +
                        ")",
                    offset: 2
                }
            ];

        case 'week':
            return [
                {
                    displayName: "this week (" + moment().format("ww") + ")",
                    offset: 0
                },
                {
                    displayName:
                        "last week (" +
                        moment()
                            .subtract(1, "weeks")
                            .format("ww") +
                        ")",
                    offset: -1
                },
                {
                    displayName:
                        "previous week (" +
                        moment()
                            .subtract(2, "weeks")
                            .format("ww") +
                        ")",
                    offset: -2
                },
                {
                    displayName:
                        "next week (" +
                        moment()
                            .add(1, "weeks")
                            .format("ww") +
                        ")",
                    offset: 1
                }
            ];

        case 'month':
            return [
                {
                    displayName: "this month (" + moment().format("MMMM") + ")",
                    offset: 0
                },
                {
                    displayName:
                        "last month (" +
                        moment()
                            .subtract(1, "months")
                            .format("MMMM") +
                        ")",
                    offset: -1
                },
                {
                    displayName:
                        "previous month (" +
                        moment()
                            .subtract(2, "months")
                            .format("MMMM") +
                        ")",
                    offset: -2
                },
                {
                    displayName:
                        "next month (" +
                        moment()
                            .add(1, "months")
                            .format("MMMM") +
                        ")",
                    offset: 1
                }
            ];

        case 'year':
            return [
                {
                    displayName: "this year (" + moment().format("YYYY") + ")",
                    offset: 0
                },
                {
                    displayName:
                        "last year (" +
                        moment()
                            .subtract(1, "years")
                            .format("YYYY") +
                        ")",
                    offset: -1
                },
                {
                    displayName:
                        "next year (" +
                        moment()
                            .add(1, "years")
                            .format("YYYY") +
                        ")",
                    offset: 1
                }
            ];
    }
}

let prepareQueryUnit = function (informationSource, fieldName) {
    let information = getInformation(informationSource, fieldName);
    if (information) {
        let filterType = information.type;
        if (Number.isInteger(filterType)) {
            filterType = commons.informationTypes.find(x => x.id == filterType).type;
        }

        let searchTypes = getSearchTypes(filterType)
        let result = {
            fieldId: information.id,
            fieldName: fieldName,
            operator: searchTypes[0].fieldName,
            system: information.system
        }

        if (
            information.type == 27 &&
            Array.isArray(information.optionList) &&
            information.optionList.length
        )   
            result.operator = 'is';

        return result;
    }

    return null
}

export default {
    querySelectionPrefix: querySelectionPrefix,
    querySelectionSuffix: querySelectionSuffix,
    getInformationType: getInformationType,
    getSearchTypes: getSearchTypes,
    getDatePredefinedselection: getDatePredefinedselection,
    prepareQueryUnit: prepareQueryUnit,
}